// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import * as SagaSchema from '../../../SagaSchema';
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListDialog_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListDialog';
  $t: string = 'SagaSchema.ListObjects.ListDialog';

  public static GetMembers(): string[] {
    return ['DialogId', 'Name', 'DialogType', 'Data', 'Profile', 'TimerOffset', 'TimerMessage'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListDialog_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public DialogId: number = 0;
  public Name: string;
  public DialogType: SagaSchema.ListObjects.DialogType = SagaSchema.ListObjects.DialogType.QandA;
  public Data: string;
  public Profile: string;
  public TimerOffset: number;
  public TimerMessage: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
